export default __webpack_public_path__ + "static/media/element_spec_95.f408ae2b.webp";